import { render } from "./HolidayCategories.vue?vue&type=template&id=d4c70174&scoped=true"
import script from "./HolidayCategories.vue?vue&type=script&lang=js"
export * from "./HolidayCategories.vue?vue&type=script&lang=js"

import "./HolidayCategories.vue?vue&type=style&index=0&id=d4c70174&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4c70174"]])

export default __exports__